export default "__VITE_ASSET__Dt1fVMKv__"